import theme from '../../theme/news12'
import redesignedTheme from '../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css.div`
  .wrapper {
    display: flex;
    padding: 12px;
    flex-direction: column;
  }  

  .container-weather {
    display: flex;
    flex-direction: column;
    box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.1);
    background-color: ${theme.colors.brilliance};
    box-sizing: border-box;
    justify-content: space-around;
  }
  
  .container-weekly-conditions {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: space-between;
  }
  
  .day {
    cursor: pointer;
    border-bottom: 1px solid ${theme.colors.lightGray} 
  }
  
  /*  TOP  */
  
  .top {
    padding: 24px 16px 21px 16px;
    color: ${redesignedTheme.colors.mineShaft};
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.4s ease-in-out;
  }
  
  .top.open {
    background-color: ${redesignedTheme.colors.lightBlue};
    color: ${theme.colors.white};
    transition: all 0.4s ease-in-out;
  }
  
  .container-date {
    display: flex;
    flex-direction: column;
  }
  
  .date {
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
  }
  
  .container-weather-icon {
    width: 40px;
    height: 40px;
    display: flex;
    margin-right: 25px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  
  .container-temperatures, .top, .container-icon-summary, .container-precipitation {
    display: flex;
    align-items: center;
  }
  
  .container-temperatures {
    margin-bottom: 8px;
  }
  
  .min-temperature:after, .max-temperature:after {
    content: ${`"\\00b0"`};
  }
  
  .max-temperature {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
  }

  .min-temperature:before {
    content: '';
    border-left: 1px solid;
    display: inline-block;
    height: 8px;
    margin: 0 6px 0 5px;
  }
  
  .rain-drop-white {
    margin-right: 6px;
    transition: all 0.5s ease-in-out;
    content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='7' height='8' viewBox='0 0 7 8' fill='none'%3E%3Cpath d='M6.09578 5.2C6.09578 6.7464 4.89703 8 3.41831 8C1.93959 8 0.740845 6.7464 0.740845 5.2C0.740845 3.6536 3.41831 0 3.41831 0C3.41831 0 6.09578 3.6536 6.09578 5.2Z' fill='white'/%3E%3C/svg%3E");
  }  

  .rain-drop-black {
    margin-right: 6px;
    transition: all 0.5s ease-in-out;
    content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='7' height='8' viewBox='0 0 7 8' fill='none'%3E%3Cpath d='M6.09578 5.2C6.09578 6.7464 4.89703 8 3.41831 8C1.93959 8 0.740845 6.7464 0.740845 5.2C0.740845 3.6536 3.41831 0 3.41831 0C3.41831 0 6.09578 3.6536 6.09578 5.2Z' fill='%232C2C2C'/%3E%3C/svg%3E");
  }  
  
  .precipitation {
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
  }
  
  .precipitation:after {
    content: '%';
  }
  
  .container-caret {
    margin: 0 6px 0 20px;
  }
  
  .day:hover .top {
    color: ${theme.colors.lightBlue};
  }  
  
  .day:hover .top.open {
    color: ${theme.colors.white};
  }

  /* BOTTOM */

  .bottom {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.4s ease-in-out;
  }

  .bottom.open {
    max-height: 1000px;
    overflow: auto;
    transition: max-height 0.4s ease-in-out;
  }
  
  .bottom-padding {
    padding: 24px;
    padding-bottom: 42px;
  }
  
  .details-day {
    padding: 0 0 24px 0;
    border-bottom: 1px solid ${theme.colors.mourineGray};
  }
  
  .details-night {
    padding: 24px 0 0 0;
  }
  
  .details-night-heading {
    display: block;
    margin-bottom: 16px;
  }
    
  .description {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    color: ${theme.colors.codGray};
    margin: 0 0 24px 0;
  }
  
  .heading.primary {
    font-weight: 500;
    color: ${theme.colors.codGray};
  }
  
  .heading.secondary {
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: ${theme.colors.mouseGray};
  }
  
  .row {
    display: flex;
    justify-content: flex-start;
  }
  
  .row span {
    width: 134px;
  }
  
  .row:first-of-type {
    margin: 0 0 6px 0;
  }

  .row:nth-of-type(2) {
    margin: 0 0 24px 0;
  }

  .row:nth-of-type(3) {
    margin: 0 0 9px 0;
  }
  
  .data.primary {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: ${theme.colors.codGray};
  }
  
  .data.secondary {
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: ${theme.colors.mouseGray};
  }
  
  @media only screen and (min-width: 1023px) {
    .container-weather {
      width: 316px;
    }
  }
`
